<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.loadProducts') + ' ' + this.$route.params.code">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md2 sm3 xs12">
                <va-input
                  :label="$t('forms.inputs.sequence')"
                  v-model="loadProductParams.deliverySequence"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="codIntegration"
                  :label="$t('forms.selects.product') + '  ' + loadProductParams.name"
                />
              </div>
              <div class="flex md1 sm1 xs12">
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-search"
                  class="mr-1"
                  @click="getProduct(codIntegration)"
                />
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-close"
                  class="mr-1"
                  @click="resetlabel()"
                />
              </div>

              <div class="flex md2 sm3 xs12">
                <va-input
                  :label="$t('forms.inputs.quantity')"
                  v-model="loadProductParams.quantity"
                />
              </div>
              <div class="flex md2 sm3 xs12">
                <va-toggle
                  v-model="loadProductParams.box"
                  :label="$t('forms.controls.checkBox')"
                  :color="$themes.secondary"
                  small
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="clientName"
                  label="Busca de Cliente"
                />
              </div>
              <div class="flex md1 sm1 xs12">
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-search"
                  class="mr-1"
                  @click="getClientByName(clientName)"
                />
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-close"
                  class="mr-1"
                  @click="resetlabelClient()"
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-select
                  label="Selecionar Cliente Pesquisado"
                  v-model="loadProductParams.client"
                  keyBy="id"
                  textBy="name"
                  :options="clients"
                  searchable
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-plus"
                  class="ma-0"
                  @click="create(loadProductParams)"
                >
                  {{ $t('menu.add') }}
                </va-button>
              </div>
              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-plus"
                  class="ma-0"
                  @click="getSapLoadProducts(loadId)"
                >
                  {{ $t('menu.importSap') }}
                </va-button>
              </div>
              <div lass="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-2"
                  to="/admin/tables/loads"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>

            <div class="row">
              <div class="flex md2 sm3 xs12">
                  <va-card class="mb-2" color="secondary">
                    <p class="display-2 mb-0" style="color: white">{{ infoBox.value }}</p>
                    <p style="color: white">{{ infoBox.text }}</p>
                  </va-card>
              </div>
              <div class="flex md2 sm3 xs12">
                  <va-card class="mb-2" color="secondary">
                    <p class="display-2 mb-0" style="color: white">{{ infoUnits.value }}</p>
                    <p style="color: white">{{ infoUnits.text }}</p>
                  </va-card>
              </div>
            </div>

            <va-data-table
              :fields="fields"
              :data="agroupedLoadProducts"
              no-pagination
              :loading="loading"
            >
              <template slot="actions" slot-scope="props">
                <va-button 
                  small 
                  inline 
                  color="danger" 
                  icon="fa fa-remove"
                  class="ma-0"
                  @click="showModalRemove = true, codeLoadProduct = props.rowData.id" 
                >
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
            </va-data-table>
              <va-modal
                v-model="showModalRemove"
                size="small"
                :title="$t('modal.remove')"
                :message="$t('modal.messageRemoveLoadProduct')"
                hideDefaultActions
                :color="this.$themes.secondary"
              >
              <va-button
                color="danger"
                class="ma-2"
                @click="showModalRemove = false">
                {{$t('modal.cancel')}}
              </va-button>

              <va-button
                color="green"
                class="ma-2"
                @click="removeAgroupedLoadProduct(codeLoadProduct), showModalRemove = false">
                {{$t('modal.confirm')}}
              </va-button>
            </va-modal>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import CountriesList from '../../../data/CountriesList'
import LoadAPI from '@/services/LoadAPI'
import LocalityAPI from '@/services/LocalityAPI'
import ClientAPI from '@/services/ClientAPI'
import UserAppAPI from '@/services/UserAppAPI'
import LoadProductAPI from '@/services/LoadProductAPI'
import ProductAPI from '@/services/ProductAPI'
import * as spinners from 'epic-spinners'
import moment from 'moment'
import { showError } from '@/global'

export default {
  name: 'form-loads',
  components: {
    ...spinners,
  },
  data () {
    return {
      loadProductParams: {
        deliverySequence: '',
        client: '',
        product: {
          id: ''
        },
        quantity: '',
        loadId: '',
        box: true,
        name: ''
      },      
      agroupedLoadProductParams: {
        product: {
          id: ''
        },
        quantity: '',
        loadId: '',
        box: true,
        name: ''
      },
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModalRemove: false,
      codePackage: "",
      loadProducts: [],
      agroupedLoadProducts: [],
      clients: [],
      products: [],
      lastSequence: 1,
      load: '',
      loading: true,
      codIntegration: '',
      clientName: '',
      infoBox: {
        text: 'Quantidade de Caixas',
        value: ''
      },
      infoUnits: {
        text: 'Quantidade de Unidades',
        value: ''
      }
    }
  },
  mounted () {
    this.readItems()
  },
  computed: {
    fields () {

      return [{
        name: 'id',
        title: this.$t('tables.loadProducts.id'),
        width: '3%',
      },
      {
        name: 'delivery_sequence',
        title: this.$t('tables.loadProducts.deliverySequence'),
        width: '3%',
      },
      {
        name: 'client',
        title: this.$t('tables.loadProducts.client'),
        width: '30%',
      },
      {
        name: 'product_integration_id',
        title: this.$t('forms.inputs.integrationId'),
        width: '10%',
      },
      {
        name: 'product',
        title: this.$t('tables.loadProducts.product_name'),
        width: '40%',
      },
      {
        name: 'box',
        title: this.$t('tables.loadProducts.box'),
        width: '3%',
      },
      {
        name: 'quantity',
        title: this.$t('tables.loadProducts.quantity'),
        width: '3%',
      },
      {
        name: 'fragility',
        title: this.$t('tables.loadProducts.fragility'),
        width: '10%',
      },
      {
        name: 'package',
        title: this.$t('tables.loadProducts.package'),
        width: '10%',
      },
      {
        name: 'ballast',
        title: this.$t('tables.loadProducts.ballast'),
        width: '3%',
      },
      {
        name: 'weight',
        title: this.$t('tables.loadProducts.weight'),
        width: '3%',
      },
      {
        name: 'length',
        title: this.$t('tables.loadProducts.length'),
        width: '3%',
      },
      {
        name: 'width',
        title: this.$t('tables.loadProducts.width'),
        width: '3%',
      },
      {
        name: 'height',
        title: this.$t('tables.loadProducts.height'),
        width: '3%',
      },
      {
        name: 'full_pallet',
        title: this.$t('tables.loadProducts.full_pallet'),
        width: '3%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      // return spinners.SpinnerName
      return spinners.ScalingSquaresSpinner
    }
  },
  methods: {
    async readItems() {

      this.loading = true
      this.loadId = this.$route.params.loadId

      await LoadAPI.getLoadById(this.loadId).then(response => {
        this.infoBox.value = response.data.load.quantity_boxes
        this.infoUnits.value = response.data.load.quantity_units
      })

      await LoadProductAPI.getAgroupedLoadProductsByLoadID(this.loadId).then(response => {
        this.agroupedLoadProducts = response.data.agrouped_load_products
      })

      this.loading = false
    },
    resetlabel() {
      this.loadProductParams.name = ""
      this.codIntegration = ""
      this.loadProductParams.product.id = ""
    },
    resetlabelClient() {
      this.clientName = ""
      this.loadProductParams.client = ""
    },
    getProduct(codIntegration) {
      ProductAPI.getProductByIdIntegration(codIntegration).then(response => {
        this.loadProductParams.product.id = response.data.product.id
        this.loadProductParams.name = response.data.product.name
      }).catch(e => {
        showError(e)
      });
    },
    getClientByName(clientName) {
      let clientNameEncoded = encodeURI(clientName)
      ClientAPI.getClientByName(clientNameEncoded).then(response => {
        this.clients = response.data.clients
      }).catch(e => {
        showError(e)
      });
    },
    getAllLoadProducts() {
      this.loadProductParams.loadId = this.$route.params.loadId
      LoadProductAPI.getLoadProductsByloadId(this.loadProductParams.loadId).then(response => {
        this.loadProducts = response.data.load_products
        this.loading = false
      })
    },
    getAllAgroupedLoadProducts() {
      this.loadProductParams.loadId = this.$route.params.loadId
      LoadProductAPI.getlAgroupedLoadProductsByloadId(this.loadProductParams.loadId).then(response => {
        this.loadProducts = response.data.agrouped_load_products
        this.loading = false
      })
    },
    create (loadProductParams) {
      if (loadProductParams.client == '' || loadProductParams.product == '' ||
          loadProductParams.quantity == '' || loadProductParams.deliverySequence == '') {
        this.showToast(this.$t('toast.allFieldsMustBeFilled'), {
          icon: 'fa-exclamation',
          position: 'top-right',
        })
      } else {
        LoadProductAPI.createLoadProduct(loadProductParams).then(response => {
          this.getAllLoadProducts();

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      }
    },

    getSapLoadProducts (loadId) {
      this.loading = true
      LoadAPI.getSapLoadProducts(loadId).then(response => {
        
        this.loadProducts = response.data.load_products
        this.loading = false

        this.readItems()

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    remove (loadProductID) {
      LoadProductAPI.removeLoadProduct(loadProductID).then(response => {

        const rowItem = this.loadProducts.map((e) => e.id).indexOf(loadProductID)
        this.loadProducts.splice(rowItem, 1)

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    removeAgroupedLoadProduct (agroupedLoadProductId) {
      LoadProductAPI.removeAgroupedLoadProduct(agroupedLoadProductId).then(response => {

        this.readItems()

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
